import SortAscendingIcon from "@/icons/SortAscendingIcon";
import SortDescendingIcon from "@/icons/SortDescendingIcon";

import DotsHorizontalIcon from "@/icons/DotsHorizontalIcon";
import ChevronDownIcon from "@/icons/ChevronDownIcon";
import DotsCircleHorizontalIcon from "@/icons/DotsCircleHorizontalIcon";
import ChevronDoubleUpIcon from "@/icons/ChevronDoubleUpIcon";
import ChevronUpIcon from "@/icons/ChevronUpIcon";
import LightningBoltIcon from "@/icons/LightningBoltIcon";

import TagIcon from "@/icons/TagIcon";
import CheckCircleIcon from "@/icons/CheckCircleIcon";
import ExclamationIcon from "@/icons/ExclamationIcon";
import ClockIcon from "@/icons/ClockIcon";
import ExclamationCircleIcon from "@/icons/ExclamationCircleIcon";
import PauseIcon from "@/icons/PauseIcon";
import DocumentIcon from "@/icons/DocumentIcon";

import CollectionIcon from "@/icons/CollectionIcon";
import CheckIcon from "@/icons/CheckIcon";
import LockCloseIcon from "@/icons/LockClosedIcon";

import DocumentTextIcon from "@/icons/DocumentTextIcon";
import BugIcon from "@/icons/BugIcon";
import CrownIcon from "@/icons/CrownIcon";
import MilestoneIcon from "@/icons/MilestoneIcon";
import LightBulbIcon from "@/icons/LightBulbIcon";
import WandIcon from "@/icons/WandIcon";
import ReleaseIcon from "@/icons/ReleaseIcon";

import { Flex } from "antd";
import RefreshIcon from "@/icons/RefreshIcon";

const NOT_FILLED_OPTION = {
  uuid: "notFilled",
  name: "Не заполнено",
  label: "Не заполнено",
};

const SORT_BY = [
  { value: "name", label: "По названию" },
  { value: "status", label: "По статусу" },
  { value: "date", label: "По дате создания" },
  { value: "dateEnd", label: "По сроку исполнения" },
];

const VIEW_TYPES = {
  LIST: "list",
  CARDS: "cards",
  KANBAN: "kanban",
};

const FILTER_NAMES = {
  SEARCH: "search", // поиск
  STATUS_UUID: "status_uuid", // статус
  IMPORTANCE_UUID: "importance_uuid", // приоритет
  AUTHOR_UUID: "author_uuid", // автор
  RESPONSIBLE_EXECUTOR_UUID: "responsible_executor_uuid", // исполнитель
  UNIT_UUID: "unit_uuid", // рабочая группа (для админа)
  UNITS_UUIDS: "units_uuids", // рабочие группы (для пользователя)
  ACCESS_LEVEL: "access_level", // уровень доступа (для пользователя)
  COPY_TRANSACTION_ID: "copy_transaction_id", // id транзакции копирования
  TASKS_UUIDS: "uuid", // uuid-ы задач для вывода в список задач
  SPRINT_UUID: "sprint_uuid", // спринт
};

const ACCESS_LEVELS = [
  {
    label: "Все",
    value: "all",
    icon: <CollectionIcon style={{ fontSize: 14 }} />,
  },
  {
    label: "Вы участник",
    value: "root",
    icon: <CheckIcon style={{ fontSize: 14 }} />,
  },
  {
    label: "Вы читатель",
    value: "child",
    icon: <LockCloseIcon style={{ fontSize: 14 }} />,
  },
];

const PRIORITY_OPTIONS = [
  {
    label: "пустой",
    value: "geekblue",
    icon: <DotsHorizontalIcon style={{ color: "#777777" }} />,
  },
  {
    label: "низкий",
    value: "lime",
    icon: <ChevronDownIcon style={{ color: "#1FB8D3" }} />,
  },
  {
    label: "блокирован",
    value: "magenta",
    icon: <DotsCircleHorizontalIcon style={{ color: "#CF60B7" }} />,
  },
  {
    label: "высокий",
    value: "volcano",
    icon: <ChevronDoubleUpIcon style={{ color: "#1230F1" }} />,
  },
  {
    label: "средний",
    value: "gold",
    icon: <ChevronUpIcon style={{ color: "#A643F2" }} />,
  },
  {
    label: "срочный",
    value: "orange",
    icon: <LightningBoltIcon style={{ color: "#E66A25" }} />,
  },
];

const STATUS_OPTIONS = [
  {
    label: "не начата",
    value: "blue",
    icon: <TagIcon />,
  },
  {
    label: "на исполнении",
    value: "purple",
    icon: <ClockIcon />,
  },
  {
    label: "удалена",
    value: "red",
    icon: <ExclamationIcon />,
  },
  {
    label: "приемка",
    value: "orange",
    icon: <PauseIcon />,
  },
  {
    label: "завершена",
    value: "green",
    icon: <CheckCircleIcon />,
  },
  {
    label: "отложена",
    value: "cyan",
    icon: <ExclamationCircleIcon />,
  },
  {
    label: "черновик",
    value: "magenta",
    icon: <DocumentIcon />,
  },
  {
    label: "планируется",
    value: "gray",
    icon: <RefreshIcon />,
  },
  {
    label: "отменена",
    value: "default",
    icon: <ExclamationCircleIcon />,
  },
];

const STATUS_COLORS = {
  magenta: {
    dot: "#dfdfdf",
    progress: "#777777",
  },
  green: {
    dot: "#64d976",
    progress: "#249F5D",
  },
  blue: {
    dot: "#8fb9ff",
    progress: "#367AF0",
  },
  purple: {
    dot: "#c39bf5",
    progress: "#8C5CC8",
  },
  orange: {
    dot: "#f7a451",
    progress: "#E68525",
  },
  red: {
    dot: "#ff7266",
    progress: "#EC4032",
  },
  cyan: {
    dot: "#63c9e0ff",
    progress: "#4091AE", // может #a2dfed ?
  },
  gray: {
    dot: "#999999",
    progress: "#777777",
  },
  default: {
    dot: "#d9d9d9",
    progress: "#8c8c8c",
  },
};

const isTaskStatusFinal = (status) =>
  !!(
    status?.is_for_completion ||
    status?.is_for_deletion ||
    status?.is_for_cancellation
  );

const getTaskFinalStatusName = (status) => {
  if (status?.is_for_completion) return "Завершена";
  if (status?.is_for_deletion) return "Удалена";
  if (status?.is_for_cancellation) return "Отменена";

  return status?.name || "";
};
const TASK_TYPE_OPTIONS = [
  {
    label: "задача",
    value: "task",
    icon: <DocumentTextIcon />,
  },
  {
    label: "ошибка",
    value: "bug",
    icon: <BugIcon />,
  },
  {
    label: "эпик",
    value: "epic",
    icon: <CrownIcon />,
  },
  {
    label: "веха",
    value: "milestone",
    icon: <MilestoneIcon />,
  },
  {
    label: "новая возможность",
    value: "feature",
    icon: <LightBulbIcon />,
  },
  {
    label: "улучшение",
    value: "improvement",
    icon: <WandIcon />,
  },
  {
    label: "инциндент",
    value: "incident",
    icon: <LightningBoltIcon />,
  },
  {
    label: "релиз",
    value: "release",
    icon: <ReleaseIcon />,
  },
];

const SORT_OPTIONS = [
  {
    key: "-created_at",
    value: "-created_at",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Дата создания
      </Flex>
    ),
  },
  {
    key: "created_at",
    value: "created_at",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Дата создания
      </Flex>
    ),
  },
  {
    key: "-due_date",
    value: "-due_date",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Срок исполнения
      </Flex>
    ),
  },
  {
    key: "due_date",
    value: "due_date",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Срок исполнения
      </Flex>
    ),
  },
  {
    key: "-task_number",
    value: "-task_number",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Номер задачи
      </Flex>
    ),
  },
  {
    key: "task_number",
    value: "task_number",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Номер задачи
      </Flex>
    ),
  },
  {
    key: "-executor.fullname",
    value: "-executor.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Исполнитель
      </Flex>
    ),
  },
  {
    key: "executor.fullname",
    value: "executor.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Исполнитель
      </Flex>
    ),
  },
  {
    key: "-author.fullname",
    value: "-author.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Автор
      </Flex>
    ),
  },
  {
    key: "author.fullname",
    value: "author.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Автор
      </Flex>
    ),
  },
  {
    key: "-status.idx,status.name",
    value: "-status.idx,status.name",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Статус
      </Flex>
    ),
  },
  {
    key: "status.idx,status.name",
    value: "status.idx,status.name",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Статус
      </Flex>
    ),
  },
  {
    key: "-importance.idx,importance.name",
    value: "-importance.idx,importance.name",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Приоритет
      </Flex>
    ),
  },
  {
    key: "importance.idx,importance.name",
    value: "importance.idx,importance.name",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Приоритет
      </Flex>
    ),
  },
  {
    key: "-is_recurring",
    value: "-is_recurring",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Повторение
      </Flex>
    ),
  },
  {
    key: "is_recurring",
    value: "is_recurring",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Повторение
      </Flex>
    ),
  },
];

const USER_ROLES = {
  AUTHOR: "author", // автор задачи
  RESPONSIBLE_EXECUTOR: "responsible_executor", // ответственный исполнитель задачи
  COEXECUTOR: "coexecutor", // соисполнитель задачи
  UNIT_MEMBER: "unit_member", // просто сотрудник РГ, не участвующий в задаче
  UNIT_MANAGER: "unit_manager", // руководитель РГ
  ADMINISTRATOR: "administrator", // администратор организации
  ACCEPTOR: "assignee_acceptor", // приемщик задачи
};
// Можно ли было сделать один массив и отдавать его в большинстве случаев? Возможно
// Но так более гибко, на случай если начнется расширение прав
const STATUS_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.RESPONSIBLE_EXECUTOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
  // USER_ROLES.ACCEPTOR,
];
const NAME_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const PRIORITIES_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const DESCRIPTION_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const AUTHOR_EDIT_ROLES = [USER_ROLES.UNIT_MANAGER, USER_ROLES.ADMINISTRATOR];
const EXECUTOR_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const EXECUTOR_SET_ME_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.COEXECUTOR,
  USER_ROLES.UNIT_MEMBER,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
  USER_ROLES.ACCEPTOR,
];
const ACCEPTOR_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.ADMINISTRATOR,
  USER_ROLES.UNIT_MANAGER,
];
const ACCEPTOR_SET_ME_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.ADMINISTRATOR,
  USER_ROLES.UNIT_MANAGER,
];
const START_DATE_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const DUE_DATE_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const PARENT_TASK_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const FILES_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.RESPONSIBLE_EXECUTOR,
  USER_ROLES.COEXECUTOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
  USER_ROLES.ACCEPTOR,
];
const OBJECTS_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.RESPONSIBLE_EXECUTOR,
  USER_ROLES.COEXECUTOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const COEXECUTOR_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.RESPONSIBLE_EXECUTOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const CHECKLIST_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const CHECKLIST_TOGGLE_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
  USER_ROLES.ACCEPTOR,
];
const EDIT_PLANNED_LABOR_COSTS_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];
const TASK_TYPES_EDIT_ROLES = [
  USER_ROLES.AUTHOR,
  USER_ROLES.UNIT_MANAGER,
  USER_ROLES.ADMINISTRATOR,
];

const TASK_SPRINT_EDIT_ROLES = [USER_ROLES.AUTHOR, USER_ROLES.ADMINISTRATOR];

const LOCAL_STORAGE_KEY = "tasksTableParams";
const TASK_EXPORT_ENABLED = false;
const TASK_EXPORT_FIELDS_LOCAL_STORAGE_KEY = "taskExportFields";

const TASK_FIELD_LABELS = {
  task_number: "№",
  importance_uuid: "Приоритет",
  status_uuid: "Статус",
  is_recurring: "Повторение",
  name: "Название",
  description: "Описание",
  task_type_uuid: "Тип задачи",
  created_at: "Дата создания",
  author: "Автор",
  executor: "Исполнитель",
  assignee_acceptor: "Приемщик",
  parent_task_number: "№ род. задачи",
  parent_task_name: "Название родительской задачи",
  start_date: "Дата начала",
  due_date: "Срок исполнения",
  location: "Местоположение",
  unit: "Рабочая группа",
  planned_costs: "Планируемые трудозатраты",
  actual_costs: "Фактические трудозатраты",
  sprint_uuid: "Спринт",
};

const TASK_EXPORT_FIELDS = [
  { name: "task_number", title: TASK_FIELD_LABELS.task_number, type: "number" },
  { name: "name", title: TASK_FIELD_LABELS.name, type: "string" },
  { name: "description", title: TASK_FIELD_LABELS.description, type: "string" },
  { name: "task_type", title: TASK_FIELD_LABELS.task_type_uuid, type: "string" },
  { name: "importance", title: TASK_FIELD_LABELS.importance_uuid, type: "string" },
  { name: "status", title: TASK_FIELD_LABELS.status_uuid, type: "string" },
  { name: "is_recurring", title: TASK_FIELD_LABELS.is_recurring, type: "boolean" },
  { name: "author", title: TASK_FIELD_LABELS.author, type: "employee" },
  {
    name: "responsible_executor",
    title: TASK_FIELD_LABELS.executor,
    type: "employee",
  },
  {
    name: "assignee_acceptor",
    title: TASK_FIELD_LABELS.assignee_acceptor,
    type: "employee",
  },
  {
    name: "parent_task_number",
    title: TASK_FIELD_LABELS.parent_task_number,
    type: "number",
  },
  {
    name: "parent_task_name",
    title: TASK_FIELD_LABELS.parent_task_name,
    type: "string",
  },
  { name: "start_date", title: TASK_FIELD_LABELS.start_date, type: "date" },
  { name: "due_date", title: TASK_FIELD_LABELS.due_date, type: "datetime" },
  { name: "unit", title: TASK_FIELD_LABELS.unit, type: "string" },
  { name: "planned_costs", title: TASK_FIELD_LABELS.planned_costs, type: "number" },
  { name: "actual_costs", title: TASK_FIELD_LABELS.actual_costs, type: "number" },
  { name: "sprint", title: TASK_FIELD_LABELS.sprint_uuid, type: "string" },
  { name: "location", title: TASK_FIELD_LABELS.location, type: "location" },
];

const getTaskExportFieldNames = () => TASK_EXPORT_FIELDS.map(({ name }) => name);
const getTaskExportField = (name) =>
  TASK_EXPORT_FIELDS.find((field) => field.name === name) || null;

const getLocalStorageKey = (userUuid, unitUuid, isAdmins) =>
  `${userUuid}_${LOCAL_STORAGE_KEY}_${unitUuid || ""}_${
    isAdmins ? "admins" : ""
  }`;

const getInitialTableParams = (unit_uuid) => ({
  select_view: VIEW_TYPES.LIST,
  pagination: {
    current: 1,
    pageSize: 12,
    pageSizeOptions: [12, 24, 48, 96],
    placement: ["bottomLeft"],
    showSizeChanger: true,
  },
  filters: {
    search: null,
    status_uuid: [],
    importance_uuid: null,
    task_type_uuid: null,
    author_uuid: null,
    responsible_executor_uuid: null,
    unit_uuid: unit_uuid || null,
    units_uuids: [],
    access_level: "all",
    copy_transaction_id: null,
  },
  sort: SORT_OPTIONS[0].value,
});

export {
  NOT_FILLED_OPTION,
  SORT_BY,
  ACCESS_LEVELS,
  VIEW_TYPES,
  FILTER_NAMES,
  SORT_OPTIONS,
  LOCAL_STORAGE_KEY,
  PRIORITY_OPTIONS,
  STATUS_OPTIONS,
  TASK_TYPE_OPTIONS,
  USER_ROLES,
  STATUS_EDIT_ROLES,
  NAME_EDIT_ROLES,
  PRIORITIES_EDIT_ROLES,
  DESCRIPTION_EDIT_ROLES,
  AUTHOR_EDIT_ROLES,
  EXECUTOR_EDIT_ROLES,
  EXECUTOR_SET_ME_ROLES,
  START_DATE_EDIT_ROLES,
  DUE_DATE_EDIT_ROLES,
  PARENT_TASK_EDIT_ROLES,
  FILES_EDIT_ROLES,
  OBJECTS_EDIT_ROLES,
  COEXECUTOR_EDIT_ROLES,
  ACCEPTOR_EDIT_ROLES,
  ACCEPTOR_SET_ME_ROLES,
  CHECKLIST_EDIT_ROLES,
  CHECKLIST_TOGGLE_ROLES,
  STATUS_COLORS,
  isTaskStatusFinal,
  getTaskFinalStatusName,
  EDIT_PLANNED_LABOR_COSTS_ROLES,
  TASK_TYPES_EDIT_ROLES,
  TASK_SPRINT_EDIT_ROLES,
  TASK_FIELD_LABELS,
  TASK_EXPORT_ENABLED,
  TASK_EXPORT_FIELDS,
  TASK_EXPORT_FIELDS_LOCAL_STORAGE_KEY,
  getTaskExportFieldNames,
  getTaskExportField,
  getLocalStorageKey,
  getInitialTableParams,
};
